import * as shared from "@/styles/shared";
import type { IconComponent } from "@/types/ui";
import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import * as styles from "./PageHeader.styles";

interface PageHeaderProps {
  title: string;
  icon?: IconComponent;
  description?: string;
  action?: ReactNode;
  onBack?: () => void;
  backLabel?: string;
}

const PageHeader = ({ title, icon: Icon, description, action, onBack, backLabel = "Back" }: PageHeaderProps) => {
  const textOnly = !onBack && !action;
  return (
    <div className={textOnly ? styles.headerMobileHidden : styles.header}>
      <div className={styles.left}>
        {onBack && (
          <button onClick={onBack} className={styles.backBtn} aria-label={backLabel}>
            <ChevronLeft className={shared.iconMd} />
          </button>
        )}
        {Icon && <Icon className={textOnly ? styles.icon : styles.iconMobileHidden} />}
        <div className={textOnly ? styles.textGroup : styles.textGroupMobileHidden}>
          <h1 className={styles.title}>{title}</h1>
          {description && <p className={styles.description}>{description}</p>}
        </div>
      </div>
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
};

export { PageHeader };
export type { PageHeaderProps };
